import { render, staticRenderFns } from "./CalendarWeekDay.vue?vue&type=template&id=15ae7428&lang=pug&"
import script from "./CalendarWeekDay.vue?vue&type=script&lang=js&"
export * from "./CalendarWeekDay.vue?vue&type=script&lang=js&"
import style0 from "./CalendarWeekDay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports